var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.400391 1.0002C0.400391 0.558367 0.758563 0.200195 1.20039 0.200195H10.8004C11.2422 0.200195 11.6004 0.558367 11.6004 1.0002C11.6004 1.44202 11.2422 1.8002 10.8004 1.8002H1.20039C0.758563 1.8002 0.400391 1.44202 0.400391 1.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00039 5.0002C2.00039 4.55837 2.35856 4.2002 2.80039 4.2002H9.20039C9.64222 4.2002 10.0004 4.55837 10.0004 5.0002C10.0004 5.44202 9.64222 5.8002 9.20039 5.8002H2.80039C2.35856 5.8002 2.00039 5.44202 2.00039 5.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.400391 9.0002C0.400391 8.55837 0.758563 8.2002 1.20039 8.2002H10.8004C11.2422 8.2002 11.6004 8.55837 11.6004 9.0002C11.6004 9.44202 11.2422 9.8002 10.8004 9.8002H1.20039C0.758563 9.8002 0.400391 9.44202 0.400391 9.0002Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/align-center.3ca0aed32fee3cd9e2b3021a77f9f269.svg";
export { ForwardRef as ReactComponent };